module.exports = __webpack_public_path__ + "img/female_avatar.819dd867.svg";